import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Text input primitive — used by the Help tab's search box and the
 * (Day 2+) message composer. Tokenised so brand radius/border/bg
 * propagate from operator overrides.
 *
 * Composer-style "input with leading icon" usage:
 *
 *     <div className="relative">
 *       <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 …" />
 *       <Input className="pl-10" placeholder="Search…" />
 *     </div>
 */
export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      "h-11 w-full rounded-wx bg-wx-bg-elevated px-4 text-sm text-wx-fg",
      "placeholder:text-wx-fg-muted",
      "focus:outline-none focus:ring-2 focus:ring-wx-primary",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";
